import React, { Component } from 'react';
import { bool, shape } from 'prop-types';
import { connect } from 'react-redux';

import EbookViews from './views';


class EBook extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      isShown,
      annotation: { isOpen },
      notifications: { createPageViewerFail, isLoading }
    } = this.props;

    const styles = {
      overflow: 'hidden',
      visibility: isShown ? 'visible' : 'hidden',
      order: isShown ? '2' : '3'
    };

    const viewProps = {
      createPageViewerFail,
      isLoading,
      isOpen,
      styles
    };

    return <EbookViews { ...viewProps } />;
  }
}

EBook.propTypes = {
  annotation: shape({
    isOpen: bool
  }),
  notifications: shape({
    createPageViewerFail: bool,
    isLoading: bool
  }),
  isShown: bool
};


function mapStateToProps(state) {
  const { annotation, notifications } = state;

  return {
    annotation,
    notifications
  };
}

export default connect(mapStateToProps)(EBook);
